import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";

export default function AssetTypesChart() {
	const chartData = [
		{ value: 12, name: "Field Device" },
		{ value: 14, name: "Controller" },
		{ value: 15, name: "SCADA/HMI" },
		{ value: 3, name: "EWS/Historian" },
		{ value: 12, name: "Computer" },
		{ value: 6, name: "Network Device" },
		{ value: -1, name: "Others" },
	];

	return (
		<div className="col-lg-4 mb-3">
			<div className="card bg-secondary h-100">
				<div className="card-body">
					<h5 className="text-white mb-6">Asset Types</h5>
					<ReactECharts
						option={{
							tooltip: {
								trigger: "item",
								backgroundColor: "rgba(0, 0, 0, 0.8)",
								borderColor: "#60a5fa",
								textStyle: { color: "#fff" },
								formatter: "{b}: {c}",
							},
							legend: {
								orient: "right",
								right: 10,
								top: "center",
								textStyle: { color: "#bfcbdc", fontSize: 11 },
								data: chartData.map((item) => item.name),
							},
							series: [
								{
									type: "pie",
									center: ["35%", "50%"],
									radius: ["40%", "70%"],
									avoidLabelOverlap: false,
									label: {
										show: false,
										position: "center",
									},
									emphasis: {
										label: {
											show: true,
											fontSize: 16,
											fontWeight: "bold",
										},
									},
									itemStyle: {
										borderRadius: [4, 4, 0, 0],
										borderColor: "#1a1a24",
										borderWidth: 2,
									},
									data: chartData,
									color: [
										"#a8c5dd",
										"#3b82f6",
										"#6db3f2",
										"#8dc9f8",
										"#b0d9fc",
										"#c9e6fd",
										"#daf2fe",
									],
								},
							],
						}}
						style={{
							height: 250,
						}}
						echarts={echarts}
					/>
					<div className="text-white-50 small text-center mt-2">
						Total Assets: {chartData.reduce((sum, item) => sum + item.value, 0)}
					</div>
				</div>
			</div>
		</div>
	);
}
